export default __webpack_public_path__ + "static/media/arrow-right.3306c112.svg";